var Method;

(function (Method) {
  Method["GET"] = "GET";
  Method["POST"] = "POST";
  Method["PUT"] = "PUT";
  Method["DELETE"] = "DELETE";
  Method["HEAD"] = "HEAD";
  Method["OPTIONS"] = "OPTIONS";
  Method["TRACE"] = "TRACE";
  Method["PATCH"] = "PATCH";
})(Method || (Method = {}));

export default Method;